export default {"src":"https://cdn.bestfoodtrucks.com/_next/static/media/google-playstore.258c3d50.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};